export default __webpack_public_path__ + "static/assets/med_x_syringe.189c6fab.png";